import { Component, OnInit } from '@angular/core';
import { CommonModule } from '@angular/common';
import { DialogModule } from 'primeng/dialog';
import { ButtonModule } from 'primeng/button';
import { Router } from '@angular/router';
import { SessionExpiredDialogService } from '../../core/services/session-expired-dialog.service';

@Component({
  selector: 'app-session-expired-dialog',
  standalone: true,
  imports: [CommonModule, DialogModule, ButtonModule],
  templateUrl: './session-expired-dialog.component.html'
})
export class SessionExpiredDialogComponent implements OnInit {
  visible = false;

  constructor(
    private sessionDialog: SessionExpiredDialogService,
    private router: Router
  ) {}

  ngOnInit() {
    this.sessionDialog.visible$.subscribe(v => {
      this.visible = v;
    });
  }

  goToLogin() {
    this.sessionDialog.close();
    this.router.navigate(['/auth/get-started']);
  }
}